import React, { useEffect, useState } from "react";
import styles from "./Sections.module.scss";
import LineImage from "../assets/vertical_line.svg?react";
import Spinner from "@src/components/spinner/Spinner";
import {
  Chart as ChartJS,
  ArcElement,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Tooltip } from "antd";

ChartJS.register(
  ArcElement,
  ChartDataLabels,
);

type Props = {
  quizName: string;
  submissions: number;
  result: number;
  backGroundUrl?: string;
  loading?: boolean;
  openCard?: () => void;
  isCardBlured?: boolean;
};

function SectionsQuizCard(props: Props) {
  const {
    quizName,
    submissions,
    result,
    loading,
    openCard,
    isCardBlured = false,
  } = props;

  const guageNeedle = {
    id: "guageNeedle",
    afterDatasetsDraw: (chart: any) => {
      const {
        ctx,
        chartArea: { width }
      } = chart;
      ctx.save();
  
      const angle = Math.PI + (1 / 100) * result * Math.PI;
  
      const cx = width / 2;
      const cy = chart._metasets[0].data[0].y;

      ctx.translate(cx, cy);
      ctx.rotate(angle);
      ctx.beginPath();
      ctx.moveTo(0, -10);
      ctx.lineTo(cx - 10, 0);
      ctx.lineTo(0, 10);

      const gradient = ctx.createLinearGradient(200, 0, 0, 0);
      gradient.addColorStop(0, "rgba(0, 0, 0, 1)");
      gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

      ctx.fillStyle = gradient;
      ctx.fill();
      ctx.rotate(-angle);
      ctx.restore();
    }
  }

  const [chartData, setChartData] = useState({
    labels: ["33", "33", "33"],
    datasets: [{
      data: [3, 3, 3],
      needleValue: 20,
      backgroundColor: ['rgba(255, 190, 190, 1)', 'rgba(255, 231, 171, 1)', 'rgba(188, 229, 197, 1)'],
      borderColor: ['white', 'white', 'white'],
      borderWidth: 6,
      borderRadius: [6, 6, 6],
      hoverBorderColor: ['white', 'white', 'white'],
      circumference: 180,
      rotation: 270,
      offset: 0,
      weight: 0.5
    }],
  })

  useEffect(() => {
    if (submissions) {
      setChartData({
        labels: [`${submissions}`, `${submissions}`, `${submissions}`],
        datasets: [{
          data: [submissions, submissions, submissions],
          needleValue: 20,
          backgroundColor: ['rgba(255, 190, 190, 1)', 'rgba(255, 231, 171, 1)', 'rgba(188, 229, 197, 1)'],
          borderColor: ['white', 'white', 'white'],
          borderWidth: 6,
          borderRadius: [6, 6, 6],
          hoverBorderColor: ['white', 'white', 'white'],
          circumference: 180,
          rotation: 270,
          offset: 0,
          weight: 0.5
        }],
      })
    }  
  }, [submissions]);

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
      datalabels: {
        display: true,
        color: "white",
        font: {
          family: 'Montserrat',
          size: 8,
          weight: 600
        },
        formatter: (value: any, context: any) => {
          const labels = ["LOW", "MED", "HIGH"]
          return labels[context.dataIndex]
        },
        rotation: [300, 0, 60],
      }
    },
    cutout: '75%',
    responsive: false,
    maintainAspectRatio: false,
    width: 202,
    height: 100,
    showTooltips: false
  }

  const color = result >= 70 ? '#34AC7A' : (result >= 40 ? '#FF8E4F' : '#F03B3B')

  return (
    <Tooltip
      title={<div className={styles.tooltipText}>Click to view more detailed information</div>}
      placement="top"
      color="#FFFFFF"
    >
    <div className={`${styles.quizCard} ${isCardBlured && styles.cardOpacity}`} onClick={openCard} style={{cursor: openCard ? 'pointer' : 'default'}}>
      {loading ? <div className={styles.spinner}><Spinner /></div> :
      <>
        <div className={styles.graphView}>
        <div className={styles.quizTitle}>
            <span>{quizName}</span>
          </div>
          <div className={styles.quizGraphView}>
            <Doughnut key={submissions} options={options} data={chartData} width={202} height={100} plugins={[guageNeedle]}/>
            <div className={styles.submissionView}>
              <h2>{submissions}</h2>
              <span>Submissions</span>
            </div>
          </div>
          
        </div>
        <div className={styles.lineView}>
          <LineImage />
        </div>
        <div className={styles.resultView}>
          <div className={styles.cardTitle}>
            <span>Result</span>
            <h2 style={{color: color}}>{isCardBlured ? '' : result}<span style={{color: color}}>%</span></h2>
          </div>
        </div>
      </>}
    </div>
    </Tooltip>
  );
}

export default SectionsQuizCard;
